import { render } from "./proche_sorovlar.vue?vue&type=template&id=706d0f50&scoped=true"
import script from "./proche_sorovlar.vue?vue&type=script&lang=js"
export * from "./proche_sorovlar.vue?vue&type=script&lang=js"

import "./proche_sorovlar.vue?vue&type=style&index=0&id=706d0f50&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-706d0f50"]])

export default __exports__